import {getFlagUrlFromIso2} from './flagUrl.ts'

// Market codes as returned by GET /metrics/b2b/agencies are ISO 3166-1 alpha-2 codes
// (any of them — the backend adds new markets over time), plus the non-ISO "OTROS"
// catch-all bucket and the "UK" alias some reporting rows use instead of "GB". These
// are distinct from the primaryMarket slugs (spain/usa/canada/france/italy/australia)
// used when editing an agency — see reporting_tablas_curadas.sql in 51trips-colab-api.
const B2B_MARKET_ISO_ALIASES: Record<string, string> = {
    UK: 'GB'
}

const b2bMarketRegionNames = new Intl.DisplayNames(['es'], {type: 'region'})

export const b2bMarketLabel = (code: string): string => {
    if (code === 'OTROS') return 'Otros'
    const isoCode = B2B_MARKET_ISO_ALIASES[code] ?? code
    try {
        return b2bMarketRegionNames.of(isoCode) ?? code
    } catch {
        return code
    }
}

export const b2bMarketFlag = (code: string): string | undefined => {
    if (code === 'OTROS') return undefined
    const isoCode = B2B_MARKET_ISO_ALIASES[code] ?? code
    return getFlagUrlFromIso2(isoCode)
}
